import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

import { Assessment } from '../../../../services/assessment/assessment.mapping'

@Component({
  selector: 'app-assessment-tags',
  standalone: true,
  templateUrl: './assessment-tags.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './assessment-tags.component.scss',
})
export class AssessmentTagsComponent {
  @Input({ required: true }) assessment!: Assessment
}
